
import { component } from '@/helpers/vueTyped';
import { Tournament } from '@/components/Sport/types';
import { config } from '@/config';

interface TournamentSelectItemProps {
  tour: Tournament;
  optionSelected: (tour: Tournament) => void;
}

export default component<TournamentSelectItemProps>()({
  name: 'TournamentItem',

  functional: true,

  render(h, context) {
    const { tour, optionSelected } = context.props;
    return (
      <div
        ref={`tour-${tour.id}`}
        class='selectable-tour select-row'
        onClick={() => optionSelected(tour)}
      >
        {tour.image && <img class='tour-image' src={`${config.cdn}${tour.image}`} />}
        <div class='tour-name'>{tour.label}</div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-aff4ff04/TournamentSelectItem.vue" });